import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const MedicalBookOutline = createIcon({
  displayName: 'MedicalBookOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M4,4.5V18c0,2.10457.89543,3,2,3H19a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H5.5A1.5,1.5,0,0,1,4,4.5H4A1.5,1.5,0,0,1,5.5,3H18a1,1,0,0,1,1,1V6"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
      <path
        d="M13.625,15.125V16.5a1,1,0,0,1-1,1h-1.25a1,1,0,0,1-1-1V15.125H9a1,1,0,0,1-1-1v-1.25a1,1,0,0,1,1-1h1.375V10.5a1,1,0,0,1,1-1h1.25a1,1,0,0,1,1,1v1.375H15a1,1,0,0,1,1,1v1.25a1,1,0,0,1-1,1Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const MedicalBookTwoTone = createIcon({
  displayName: 'MedicalBookTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" color="twoToneStrokeColor">
        <path
          d="M4,4.5V18c0,2.10457.89543,3,2,3H19a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H5.5A1.5,1.5,0,0,1,4,4.5H4A1.5,1.5,0,0,1,5.5,3H18a1,1,0,0,1,1,1V6"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path d="M0,0H24V24H0Z" fill="none" />
        <Box
          as="path"
          d="M13.625,15.125V16.5a1,1,0,0,1-1,1h-1.25a1,1,0,0,1-1-1V15.125H9a1,1,0,0,1-1-1v-1.25a1,1,0,0,1,1-1h1.375V10.5a1,1,0,0,1,1-1h1.25a1,1,0,0,1,1,1v1.375H15a1,1,0,0,1,1,1v1.25a1,1,0,0,1-1,1Z"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </Box>
    </>
  ),
})

const MedicalBook: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={MedicalBookTwoTone} {...props} />
  default:
    return <CustomIcon as={MedicalBookOutline} {...props} />
  }
}

export default memo(MedicalBook)
